import { createStyles } from '@mantine/core'

import { CHART_DEMENSION_BY_SIZE } from '../constants'
import { ChartSizeType } from '../index.types'

type StyleParams = {
  backgroundColor: string
  size: ChartSizeType
}

export default createStyles((theme, { size, backgroundColor }: StyleParams) => {
  return {
    root: {
      display: 'flex',
      gap: 24,
      backgroundColor,
      'button[data-variant="secondary"]': {
        borderColor: theme.colors.gray[2],
      },
      [theme.fn.smallerThan('sm')]: {
        gap: 16,
        flexDirection: 'column',
      },
    },
    colLeft: {
      [theme.fn.largerThan('sm')]: {
        order: 2,
      },
    },
    colRight: {
      [theme.fn.largerThan('sm')]: {
        width: CHART_DEMENSION_BY_SIZE[size],
        flexShrink: 0,
        order: 1,
      },
    },
    locator: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    },
  }
})
